// Documents (lot 4.5) : chercher dans les documents indexés (le partage du NAS, sur le Pi) par leur nom, leur dossier
// ou leur texte, et ouvrir le fichier. Le passage trouvé dans le texte est montré sous le nom.

import { useEffect, useState } from 'react';

import type { Actions } from '../App';
import { EnTeteRetour, Fenetre } from '../components';
import { type DocumentIndexe, NonConnecte, api } from '../lib/api';

const taille = (o: number) => (o < 1024 * 1024 ? `${Math.max(1, Math.round(o / 1024))} Ko` : `${(o / 1024 / 1024).toFixed(1).replace('.', ',')} Mo`);
const ETATS: Record<string, string> = { a_lire: 'texte pas encore lu', sans_texte: 'scan sans texte', trop_gros: 'trop gros pour être lu', illisible: 'illisible' };

export function Documents({ actions }: { actions: Actions }) {
  const [q, setQ] = useState('');
  const [documents, setDocuments] = useState<DocumentIndexe[] | null>(null);

  useEffect(() => {
    let actif = true;
    const t = window.setTimeout(() => {
      api.documents(q.trim()).then((d) => actif && setDocuments(d)).catch((e: unknown) => {
        if (e instanceof NonConnecte) window.location.hash = '#/connexion';
        else actions.toast({ texte: (e as Error).message, erreur: true });
      });
    }, 250);
    return () => {
      actif = false;
      window.clearTimeout(t);
    };
  }, [q, actions]);

  return (
    <main className="ecran">
      <EnTeteRetour titre="Documents" retour="#/connexions" />
      <input className="saisie texte" type="search" placeholder="Chercher : « contrat assurance », « facture EDF »…" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Chercher dans les documents" />
      <Fenetre>
        {documents === null && <p className="muted" style={{ margin: 0 }}>Chargement…</p>}
        {documents?.length === 0 && <p className="muted" style={{ margin: 0 }}>{q.trim() ? 'Aucun document trouvé.' : 'Aucun document indexé pour l’instant.'}</p>}
        {documents?.map((d) => (
          <a key={d.id} className="mail" href={`/api/documents/${d.id}/fichier`} target="_blank" rel="noopener">
            <span className="sujet">{d.nom}</span>
            <small className="muted">
              {d.dossier || '/'} · {new Date(d.modifieLe).toLocaleDateString('fr-FR')} · {taille(d.taille)}{ETATS[d.texte] ? ` · ${ETATS[d.texte]}` : ''}
            </small>
            {d.passage && <small>{d.passage}</small>}
          </a>
        ))}
      </Fenetre>
    </main>
  );
}
